import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { damoAuthConfig } from '../damoauth.config';
import { isNativeApp } from './auth/utils/app.utils';

@Component({
  selector: 'damoauth-lib',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly config = inject(damoAuthConfig);

  ngOnInit(): void {
    const isNative = isNativeApp();
    if (!isNative) {
      const params = new URLSearchParams(globalThis.location.search);
      const lang = params.get('lang');
      if (lang) {
        document.cookie = `lang=${lang};path=/;domain=${this.config.domain}`;
      }
    }
  }
}
